import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, Observable, shareReplay, take } from 'rxjs';
import { SeminarDateSeriesListModel } from '../../../../../models/seminar.model';
import { UserModel } from '../../../../../models/user.model';
import { SeminarService } from '../../../../../services/seminar.service';
import {
  getSeminarDates,
  getSeminarDateString,
  getSeminarFobiPoints,
  getSeminarLocationString,
} from '../../../../../utils/seminar.utils';
import { getUserFullName } from '../../../../../utils/user.utils';
import {
  Filter,
  TableColumn,
} from '../../../../shared-components/custom-table/custom-table.component';

@Component({
  selector: 'app-contact-appointments',
  templateUrl: './contact-appointments.component.html',
  styleUrl: './contact-appointments.component.scss',
  standalone: false,
})
export class ContactAppointmentsComponent implements OnInit {
  @Input() user: UserModel;
  public isLoading = true;
  public dataSource$: Observable<any[]>;
  constructor(
    private seminarService: SeminarService,
    private router: Router
  ) {}

  public ngOnInit() {
    this.getSeminars();
  }

  private getSeminars() {
    const email = this.user?.email;
    this.dataSource$ = this.seminarService.getSeminarsByUser(email, true).pipe(
      take(1),
      map(seminarDateSeriesList => {
        this.isLoading = false;
        return seminarDateSeriesList.map(seminarDateSeries => {
          return {
            ...seminarDateSeries,
            title: seminarDateSeries.seminar.title,
            lecturer: getUserFullName(seminarDateSeries.lecturer1),
            fobiPoints: getSeminarFobiPoints(seminarDateSeries),
          };
        });
      }),
      catchError(error => {
        this.isLoading = false;
        console.error('Error fetching seminars', error);
        return [];
      }),
      shareReplay(1) // Cache the result
    );
  }

  public columns: TableColumn[] = [
    {
      columnDef: 'title',
      header: 'Inhalt',
      width: '25%',
      sortable: true,
      onCellClick: this.onCellClick.bind(this),
    },
    {
      columnDef: 'dates',
      header: 'Datum',
      width: '15%',
      filterValue: row => getSeminarDates(row),
      render: row => {
        return getSeminarDateString(row);
      },
      onCellClick: this.onCellClick.bind(this),
    },
    {
      columnDef: 'lecturer',
      header: 'Dozierende',
      width: '15%',
      fontWeight: '400',
      onCellClick: this.onCellClick.bind(this),
    },
    {
      columnDef: 'fobiPoints',
      header: 'FP',
      headerAlign: 'center',
      cellAlign: 'center',
      width: '10%',
      fontWeight: '400',
      onCellClick: this.onCellClick.bind(this),
    },
    {
      columnDef: 'modality',
      header: 'Ort',
      width: '25%',
      fontWeight: '400',
      tooltip: row => ({
        tooltipText:
          row.seminar?.modality === 'online'
            ? ''
            : getSeminarLocationString(row, true),
        position: 'top',
        autoHide: false,
      }),
      filterValue: row =>
        row.seminar?.modality === 'online'
          ? 'online'
          : getSeminarLocationString(row, false, true),
      render: row => {
        if (row.seminar?.modality === 'online') {
          return `<div class="flex-r gap-4 align-center"><i class="p-5 fa-regular fa-globe"></i> Online</div>`;
        }
        return `<div class="flex-r gap-4 align-center"><i class="p-5 fa-regular fa-map-marker-alt"></i> ${getSeminarLocationString(row, false, true)}</div>`;
      },
    },
  ];

  // Define the function that will be passed to the table component
  public onCellClick(row: SeminarDateSeriesListModel, column: any) {
    this.router.navigate([
      '/seminars',
      btoa(String(row.seminar.id)),
      btoa(String(row.dateSeriesId)),
    ]);
  }

  public filters: Filter[] = [
    {
      filteredColumn: 'dates',
      type: 'daterange',
    },
    {
      filteredColumn: 'seminar.modality',
      type: 'select',
      selectOptions: [
        {
          value: 'online',
          label: 'Online',
        },
        {
          value: 'offline',
          label: 'Vor Ort',
        },
      ],
      placeholder: 'Ort auswählen...',
      label: 'Ort',
    },
  ];
}
